// extracted by mini-css-extract-plugin
export default {"gradient":"gradientText_gradient__Zvl01"};